import React from 'react';

import styles from './styles.module.css';
import SpinnerIcon from '@/assets/spinner.svg?react';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  customSpinner?: string;
  color?: string;
}

const Loader: React.FC<LoaderProps> = ({
  size = 'medium',
  className = '',
  color = ''
}) => {
  return (
    <div
      id={`${size}-loader`}
      className={`${styles.loaderContainer} ${styles[size]} ${className}`}
    >
      <SpinnerIcon className={`${styles.spinner}`} color={color} />
    </div>
  );
};

export default Loader;
